import { BodyContentTypesEnum } from '../enums/body-content-types.enum';

export class BodyContentsModel {
    id: number;
    bodyContentType: BodyContentTypesEnum | string;
    bodyContent: string;
    bodyContentId: string;
    orderId?: number;

    constructor(bodyContentType, bodyContent, id?, bodyContentId?, orderId?) {
        this.bodyContentType = bodyContentType;
        this.bodyContent = bodyContent;
        this.bodyContentId = bodyContentId;
        this.orderId = orderId;
        this.id = id;
    }
}
